<template>
  <div class="home">
<Navigation/>
    <div class="section bg-primary-3">
    <div class="container text-center">
      <h1>Covid-19 Related Posts</h1>
      <div class="text-large">Stay up to date on the recent pandemic.</div>
    </div>
  </div>
<Posts Category="covid-19-related-posts" />


  </div>

</template>

<script>
import Navigation from "@/components/Navigation.vue"
import Posts from "@/components/PostCollection.vue"

export default {
  name: "home",
  components: {
    Navigation,
    Posts
  }
};
</script>
